module.exports = __webpack_public_path__ + "static/media/PostTop.03eb6803.png";